module.exports = __webpack_public_path__ + "static/djez-15ec7b6a6339c769fb709c8dd0339ac4.jpg";